import React from 'react';
import './header.css';

class Header extends React.Component {

    render(){
        return <div className="container-fluid p-0">
                    <div className={"form__header--"+this.props.marca}>
                        <img src={this.props.marca==="vw" && this.props.nfz!==true?process.env.REACT_APP_DOMAIN+"app/sigue-tu-volkswagen/media/sigue_vw_brand.jpg":(this.props.marca==="vw" && this.props.nfz===true?process.env.REACT_APP_DOMAIN+"es/media/VWVC_header.jpg":"")} alt="header" />
                    </div>
                </div>;
    }
}

export default Header;